export default __webpack_public_path__ + "static/media/snackHealthgenom.2291394c.svg";